import { Box, Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import CommercialBG from "../../assets/images/profiles/commerical.png";
import { useNavigate } from "react-router-dom";
import APP_ROUTES from "../../routers/routeConstants";

const Commercial = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        position: "relative",
        width: "217px",
        height: "364px",
        borderRadius: "8px",
        overflow: "hidden",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundImage: `url(${CommercialBG})`,
        padding: "232px 16px 0",
      }}
    >
      <Typography
        sx={{
          color: "var(--White, #FFF)",
          fontFamily: "HeadingNowVarTrial",
          fontSize: "20px",
          fontStyle: "normal",
          fontWeight: 750,
          lineHeight: "normal",
          marginBottom: "4px",
        }}
      >
        {t("components.commercial.scoutFor")}
      </Typography>
      <Typography
        sx={{
          color: "var(--White, #FFF)",
          fontFamily: "Inter",
          fontSize: "12px",
          fontStyle: "normal",
          fontWeight: 500,
          lineHeight: "normal",
          marginBottom: "16px",
        }}
      >
        {t("components.commercial.findTalents")}
      </Typography>
      <Button
        variant="secondary-sm"
        sx={{
          padding: "10px 12px",
          fontFamily: "HeadingNowVarTrial",
          fontSize: "14px",
          fontStyle: "normal",
          fontWeight: 600,
          lineHeight: "20px",
          border: "1px solid var(--Green---100, #008B07) !important",
          color: "var(--Green---100, #008B07) !important",
          background: "var(--White, #FFF) !important",
        }}
        onClick={() => navigate(APP_ROUTES.GO_STAR)}
      >
        {t("components.commercial.getStarted")}
      </Button>
    </Box>
  );
};

export default Commercial;
